import { Injectable } from '@angular/core';

import { NonIntegratedAppService } from '../services/non-integrated-app/non-integrated-app.service';

@Injectable({ providedIn: 'root' })
export class NonIntegratedAppFacade {
  public allApps$          = this._service.allApps$;
  public appId$            = this._service.nonIntegratedAppId$;
  public coursesFiltered$  = this._service.coursesFiltered$;
  public courseId$         = this._service.courseId$;
  public nonIntegratedApp$ = this._service.nonIntegratedApp$;
  public course$ = this._service.course$;
  public getAllCourses = this._service.getAllCourses.bind(this._service);
  public getNotIntegratedApps = this._service.getNotIntegratedApps.bind(this._service);

  constructor(private readonly _service: NonIntegratedAppService) {}

  public updateAppId(id: string): void {
    this._service.updateAppId(id);
  }

  public updateCourseId(id: string): void {
    this._service.updateCourseId(id);
  }
}
